export const siteInfo = {
  name: '网报吃瓜',
  slogan: '快讯实时刷不停，报道转载全程跟踪',
  intro:
    '网报吃瓜是一个专注热点脉络的中文资讯聚合站。我们把分散在各平台的快讯、媒体报道与转载动态收进同一条时间线，帮你快速看清一件事的起因、扩散路径与各方报道差异。',
  email: 'contact@wangbaochigua.com',
  contactNote: '内容纠错、媒体合作与线索投稿，均可通过上方邮箱与我们联系。',
  updateFreq: '每日 08:00 - 24:00 持续更新',
};

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '快讯时间线', to: '/feed' },
  { label: '专题库', to: '/topics' },
  { label: '关于我们', to: '/about' },
];

export const categories = [
  { key: '影视', desc: '剧集、电影与片场动态', icon: 'ri-film-line', count: 128 },
  { key: '综艺', desc: '节目赛制与嘉宾话题', icon: 'ri-mic-line', count: 86 },
  { key: '音乐', desc: '演出、音乐节与专辑', icon: 'ri-music-2-line', count: 64 },
  { key: '网络', desc: '社交平台热点与路人视角', icon: 'ri-chat-smile-2-line', count: 152 },
  { key: '品牌', desc: '联名、营销与消费观察', icon: 'ri-shopping-bag-3-line', count: 57 },
  { key: '科技', desc: '新品发布与数码讨论', icon: 'ri-cpu-line', count: 73 },
];

export const platformStats = [
  { value: '42,800+', label: '累计收录快讯', icon: 'ri-flashlight-line' },
  { value: '1,260', label: '跟踪中的专题', icon: 'ri-route-line' },
  { value: '310', label: '纳入追踪的媒体', icon: 'ri-newspaper-line' },
  { value: '15 min', label: '平均更新间隔', icon: 'ri-timer-line' },
];

export const testimonials = [
  {
    name: '追更的老周',
    role: '常年蹲热点的上班族',
    text: '以前追一件事要开七八个网页，现在在网报吃瓜看时间线就够了，起因和后续一条不落，还能看到不同媒体怎么写的。',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20calm%20middle%20aged%20office%20man%20with%20glasses%20warm%20cream%20background%20soft%20vector%20style&width=120&height=120&seq=avatar-chigua-01&orientation=squarish',
  },
  {
    name: '追剧不打烊',
    role: '影视区活跃观众',
    text: '最爱它的报道对比，同一件事不同媒体标题差异一眼就看出来，评论区都夸这个功能实用。',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20cheerful%20young%20woman%20with%20short%20hair%20warm%20amber%20background%20soft%20vector%20style&width=120&height=120&seq=avatar-chigua-02&orientation=squarish',
  },
  {
    name: '数码老李',
    role: '数码话题观察者',
    text: '新品发布那几天它更新得比我还快，时间线把爆料、官宣、实测串起来了，省了不少翻帖子的时间。',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20friendly%20young%20man%20with%20headphones%20teal%20background%20soft%20vector%20style&width=120&height=120&seq=avatar-chigua-03&orientation=squarish',
  },
];

export const faqList = [
  {
    q: '网报吃瓜的内容主要覆盖哪些方向？',
    a: '我们覆盖影视、综艺、音乐、网络、品牌与科技六个方向，以热点事件为单位聚合快讯、媒体报道与转载动态，并按时间线整理事件的完整脉络。',
  },
  {
    q: '快讯多久更新一次？',
    a: '站内快讯在每日 08:00 至 24:00 之间持续更新，热点集中时段平均 15 分钟左右就会出现新的收录条目，专题页会同步补充最新进展。',
  },
  {
    q: '专题页里的时间线和媒体报道有什么区别？',
    a: '时间线按发生顺序梳理事件本身的进展；媒体报道则是把不同媒体对同一节点的标题、切入角度并列出来，方便对比报道口径的差异。',
  },
  {
    q: '发现内容有误或者想提供线索怎么办？',
    a: '可以通过关于我们页面的联系方式提交纠错或线索，我们会核对来源后更新对应专题，并在时间线中标注修订记录。',
  },
  {
    q: '站内的热度数值是怎么来的？',
    a: '热度由收录条数、讨论增速与转载范围综合估算，用于呈现话题的扩散程度，仅作参考，并不代表对事件本身的任何立场判断。',
  },
];